var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("loading", { ref: "loading" }),
      _vm._v(" "),
      _vm.$auth.ready()
        ? _c(
            "transition",
            { attrs: { name: "page", mode: "out-in" } },
            [_vm.layout ? _c(_vm.layout, { tag: "component" }) : _vm._e()],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.$auth.ready()
        ? _c(
            "div",
            [
              _c("semantic-loading", {
                attrs: { active: true, text: _vm.$t("globals.loaders.loading") }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-617ab0be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-617ab0be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = F7yf
// module chunks = 1